import { FormFieldControlled } from "components/UI/FormField/FormFieldControlled";
import { RequestTypeSelect } from "components/UI/RequestTypeSelect";
import { VesselScheduleCheckboxGroupData } from "constants/checkboxGroupData.constants";
import { INPUT_FIELD_NAMES } from "constants/fieldNames.constans";
import { VALIDATION_SCHEMA } from "constants/validationSchema.constans";
import styles from "../index.module.scss";

export const VesselSchedulesApi = () => {
  return (
    <>
      <FormFieldControlled
        rules={VALIDATION_SCHEMA.toolInfo.required}
        labelTitle="How many API calls are you planning to make per month?"
        fieldName={INPUT_FIELD_NAMES.apiPerMonth}
      />
      <RequestTypeSelect
        rules={VALIDATION_SCHEMA.toolInfo.oneValue}
        fieldName={INPUT_FIELD_NAMES.vesselSchedulessearch_modes}
        label="Which search mode will you use?"
        placeholder="Select search mode"
        options={VesselScheduleCheckboxGroupData}
        className={styles.requestTypeSelect}
      />
    </>
  );
};
